import { render, staticRenderFns } from "./OAPlatform.vue?vue&type=template&id=2d24f42f&"
import script from "./OAPlatform.vue?vue&type=script&lang=js&"
export * from "./OAPlatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports